export const CHANGE_IS_MOBILE = 'CHANGE_IS_MOBILE';
